import { z } from 'zod';

export const initiatePaymentSchema = z.object({
  payerEmail: z.string().default(''),
  payerFirstName: z.string().default(''),
  payerLastName: z.string().default(''),
  successUrl: z.string().min(1, 'URL sukcesu jest wymagany'),
  errorUrl: z.string().min(1, 'URL błędu jest wymagany'),
});

export type InitiatePaymentFormData = z.infer<typeof initiatePaymentSchema>;
export type InitiatePaymentInputData = z.input<typeof initiatePaymentSchema>;

export const initiatePaymentDefaultValues: InitiatePaymentInputData = {
  payerEmail: '',
  payerFirstName: '',
  payerLastName: '',
  successUrl: '',
  errorUrl: '',
};
